import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = ({isFixed = true}) => {
    const whatsappUrl = "https://wa.me/541152400277";

    const isMobile = window.innerWidth <= 768;
    const positionStyle = isFixed ? {
        position: "fixed",
        bottom: isMobile ? "80px" : "40px",
        right: isMobile ? "20px" : "40px",
    } : {
        position: "static",
    };

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                textDecoration: "none",
                color: "white",
                width: isMobile ? "40px" : "56px",
                height: isMobile ? "40px" : "56px",
                backgroundColor: "#25D366",
                borderRadius: isMobile ? "40px" : "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                ...positionStyle,
            }}
        >
            <FaWhatsapp size={isMobile? 20 : 35} />
        </a>
    );
};

export default WhatsAppButton;
